import {
	fetchCompetitionConfig,
	fetchLeaderboardRecord,
	fetchLeaderboardRecords
} from '$lib/apis/leaderboard';
import {
	currentCompetitionConfig,
	leaderboardRecords,
	loadingCurrentCompetitionConfig,
	loadingLeaderboard,
	loadingUserCompetitionStats,
	userCurrentCompetitionStats
} from '$lib/leaderboard/store';
import type { CompetitionConfig, LeaderboardRecord, SortCriteria } from '$lib/types/leaderboard';
import { addCompetitionStatus } from '$lib/util/util';
import { get } from 'svelte/store';

export async function getLeaderboardRecords(id: string, sortCriteria: SortCriteria, count = 30) {
	try {
		let config = get(currentCompetitionConfig);
		if (config) {
			if (!get(leaderboardRecords)) loadingLeaderboard.set(true);
			const data = (await fetchLeaderboardRecords(id, sortCriteria, count)) as {
				stats: Array<LeaderboardRecord>;
			};
			if (data.hasOwnProperty('stats')) {
				const records: Array<any> = data.stats as Array<LeaderboardRecord>;
				console.log({ records });
				leaderboardRecords.set(records);
			}
			loadingLeaderboard.set(false);
		}
	} catch (e) {
		loadingLeaderboard.set(false);
	}
}

export async function getLeaderboardRecord(
	id: string,
	sortCriteria: SortCriteria,
	account: string,
	count = 1
) {
	try {
		if (!get(userCurrentCompetitionStats)) loadingUserCompetitionStats.set(true);
		const data = (await fetchLeaderboardRecord(
			id,
			sortCriteria,
			account,
			count
		)) as LeaderboardRecord;
		userCurrentCompetitionStats.set(data);

		loadingUserCompetitionStats.set(false);
	} catch (e) {
		loadingUserCompetitionStats.set(false);
	}
}

export async function setCompetitionConfig(id: string) {
	try {
		loadingCurrentCompetitionConfig.set(true);
		currentCompetitionConfig.set(undefined);
		const data: CompetitionConfig = (await fetchCompetitionConfig(id)) as CompetitionConfig;

		if (data) {
			currentCompetitionConfig.set(addCompetitionStatus(data));
		}
		loadingCurrentCompetitionConfig.set(false);
	} catch (e) {
		loadingCurrentCompetitionConfig.set(false);
	}
}

export async function getCompetitionConfig(id: string) {
	try {
		const data: CompetitionConfig = (await fetchCompetitionConfig(id)) as CompetitionConfig;
		if (data) {
			return addCompetitionStatus(data);
		}
	} catch (e) {
		console.log(e);
	}
}
